import React from "react";

function Badge({ text }) {
  return <span className="badge">{text}</span>;
}

export default Badge;